import {LegacyWBIcon} from '@wandb/common/components/elements/LegacyWBIcon';
import * as globals from '@wandb/common/css/globals.styles';
import styled from 'styled-components';

export const EditorButtonSection = styled.div`
  display: flex;
  margin: 12px;
  justify-content: flex-end;
`;

export const EmptyEditorButtonSection = styled.div`
  height: 62px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 2px 8px 2px 4px;
  margin: 4px;
  font-size: 14px;
  font-family: ${globals.fontName};
  color: ${globals.gray600};
  border-radius: 3px;
  border: 1px solid ${globals.gray500};
  :hover {
    cursor: pointer;
    color: ${globals.primary};
    border: 1px solid ${globals.primary};
  }
`;

export const ButtonIcon = styled(LegacyWBIcon)`
  && {
    font-size: 20px;
  }
`;

export const LastUpdated = styled.div`
  color: #999;
  font-size: 18px;
`;
